(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    document.querySelectorAll('.creamela-header').forEach((section) => {
      const button = section.querySelector('.creamela-header__toggle');
      const menu = section.querySelector('.creamela-header__mobile');
      if (!button || !menu || button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        const open = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!open));
        menu.hidden = open;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
